import PeriprocedureelBeleidRivaroxaban from "../../../../src/client/lta-antistolling/periprocedureel-beleid-rivaroxaban.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidRivaroxaban,
  React
};